import { Pipe, PipeTransform } from '@angular/core';
import { channels } from '@shared/constants/channels';

@Pipe({
  name: 'channel',
  standalone: false,
})
export class ChannelPipe implements PipeTransform {
  transform(value: string): string {
    return channels.find((channel) => channel.reference === value)?.title || value;
  }
}
